import { RouteButton, OrangeButtonWithIcon } from "@/components/Buttons";
import { FaRegEnvelopeOpen} from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { FaCheck } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
export function EditTaskButton({task_id}: {task_id: string}) {
    return (
        <RouteButton route={"/tasks/update_task/" + task_id} text="Edit" icon={<CiEdit />} />
    )
}

export function MarkTaskComplete({handleComplete}: {handleComplete: () => void}) {
    return (
        <OrangeButtonWithIcon onClick={handleComplete} icon={<FaCheck />}>Mark Complete</OrangeButtonWithIcon>
    )
} 

export function PingTaskButton({handlePing}: {handlePing: () => void}) {
    return (
        <OrangeButtonWithIcon onClick={handlePing} icon={<FaRegEnvelopeOpen />}>Ping Task</OrangeButtonWithIcon>
    )
}

export function DeleteTaskButton({handleDelete}: {handleDelete: () => void}) {
    return (
        <OrangeButtonWithIcon onClick={handleDelete} icon={<AiOutlineDelete />}>Delete Task</OrangeButtonWithIcon>
    )
}